import styles from './checkbox.module.scss';

type CheckboxProps = {
  onChange?: (value: boolean) => void;
  isChecked?: boolean;
  disabled?: boolean;
}

export const Checkbox = ({ onChange, isChecked, disabled }: CheckboxProps) => {

  return (
    <div className={styles.container}>
      <input type="checkbox"
             onChange={(event) => !!onChange && onChange(event.target.checked)}
             checked={isChecked}
             disabled={disabled}/>
    </div>
  );
}